<h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px">
  <div fxFlex>Sign E911 Document</div>
  <button mat-icon-button [mat-dialog-close]="null" class="button-40" [disabled]="isCreatingLocation">
    <mat-icon>close</mat-icon>
  </button>
</h1>
<mat-dialog-content class="mat-typography">
  <div id="signwell-container" style="height: 100%"></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    type="button"
    mat-stroked-button
    color="primary"
    [mat-dialog-close]="null"
    [disabled]="isCreatingLocation"
    [promiseBtn]="isCreatingLocation"
  >
    Close
  </button>
</mat-dialog-actions>
